import {
  identifyUser as amplitudeIdentifyUser,
  resetUser as amplitudeResetUser,
  trackPageView as amplitudeTrackPageView,
  initializeAmplitude,
  trackEvent,
} from './amplitude';
import { hasAnalyticsConsent } from './config';

export function initializeAnalytics(): void {
  if (!hasAnalyticsConsent()) {
    console.info('[Analytics] Analytics consent not granted — skipping initialization');
    return;
  }

  try {
    initializeAmplitude();
  } catch (error) {
    console.error('[Analytics] Amplitude initialization failed:', error);
  }
}

export function trackAnalyticsEvent(
  eventName: string,
  eventProperties?: Record<string, unknown>,
): void {
  try {
    trackEvent(eventName, eventProperties);
  } catch (error) {
    console.error('[Analytics] Amplitude trackEvent failed:', error);
  }
}

export function trackPageView(pathname: string): void {
  try {
    amplitudeTrackPageView(pathname);
  } catch (error) {
    console.error('[Analytics] Amplitude trackPageView failed:', error);
  }
}

export function identifyUser(
  userId: string | number,
  properties: import('./types').UserProperties,
): void {
  try {
    amplitudeIdentifyUser(userId, properties);
  } catch (error) {
    console.error('[Analytics] Amplitude identifyUser failed:', error);
  }
}

export function resetUser(): void {
  try {
    amplitudeResetUser();
  } catch (error) {
    console.error('[Analytics] Amplitude resetUser failed:', error);
  }
}

// Re-export for granular use
export { initializeAmplitude, trackEvent } from './amplitude';
export type { AnalyticsConfig, UserProperties } from './types';
